import { render, staticRenderFns } from "./selfPage.vue?vue&type=template&id=d9cfd760&scoped=true"
import script from "./selfPage.vue?vue&type=script&lang=js"
export * from "./selfPage.vue?vue&type=script&lang=js"
import style0 from "./selfPage.vue?vue&type=style&index=0&id=d9cfd760&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cfd760",
  null
  
)

export default component.exports